import { render, staticRenderFns } from "./GPOverrideQuestion.vue?vue&type=template&id=118b5cf7"
import script from "./GPOverrideQuestion.vue?vue&type=script&lang=js"
export * from "./GPOverrideQuestion.vue?vue&type=script&lang=js"
import style0 from "./GPOverrideQuestion.vue?vue&type=style&index=0&id=118b5cf7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports